import React, { useState } from "react";
import FlagDropdown from "./flag-dropdown";

const CountrySelector = ({ hideFlag=false,countryCodes, countryCode, setCountryCode,setAddPhoneNumber,errors,addPhoneNumber }) => {
    const [error, setError] = useState(""); // State to manage errors

    const handleInputChange = (e) => {
        const input = e.target.value.trim();
        setCountryCode(input);

        // Validate input
        const isValid = countryCodes.some((country) => country.value === input);

    };

    const selectedCountry = countryCodes.filter((country) => country.value === countryCode);

    return (
        <div className="relative">
            <label htmlFor="countryCode" className="block form_label_color pb-4">
                Phone Number <span className="text-red-600">*</span>
            </label>

            {/* Container to hold the input and flag */}
            <div className="flex gap-6">
            <div className="relative w-28">
                {/* Flag icon inside the input */}
                <div className="absolute top-0 w-6 h-4">
                    <FlagDropdown countryCodes={countryCodes} countryCode={countryCode} setCountryCode={setCountryCode} hideFlag={hideFlag} />
                </div>

            </div>
            <input
                type="number"
                id="phoneNumber"
                name="phoneNumber"
                className="border_color border text-base rounded-lg block w-full p-2.5 h-12"
                // required
                // placeholder="Your Phone Number"
                onChange={(e) => setAddPhoneNumber(e.target.value)}
                value={addPhoneNumber}
              />
            
              </div>
            {errors.addCountryCode && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{errors.addCountryCode}</p>}
            {errors.phoneNumber && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{errors.phoneNumber}</p>}
        </div>
    );
};

export default CountrySelector;
